import React from 'react';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import ContractorsForm from '../components/ContractorsForm';
import { FormType } from '../../shared/model/FormType';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';

export default class ContractorsAddScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.CONTRACTORS_ADD,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_NUEVO_CONTRATISTA')} breadcrumbs={breadcrumbs}>
                <ContractorsForm type={FormType.CREATE}/>
            </PsPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/contractors/screens/ContractorsAddScreen.js